<template>  
  <el-aside width="260px" style="background-color: rgb(238, 241, 246)">
    <el-menu class="el-menu-vertical-demo" :router="true" style="margin-bottom: 30px;">
      <el-menu-item index="/">
        <i class="el-icon-s-home"></i>
        <span>Главная страница</span>
      </el-menu-item>
      <el-menu-item v-if="isAuthenticated" index="/items">
        <i class="el-icon-collection"></i>
        <span>Коллекция предметов</span>
        <el-badge v-if="userCollectionSize > 0" :value="userCollectionSize" type="primary" style="float: right;"></el-badge>
      </el-menu-item>
      <!-- <el-menu-item v-if="isAuthenticated" index="/add-item">
        <i class="el-icon-document-add"></i>
        <span>Добавить предмет</span>
      </el-menu-item> -->
      <el-menu-item v-if="isAuthenticated" index="/item-base">
        <i class="el-icon-receiving"></i>
        <span>База предметов</span>
        <el-badge v-if="itemBaseSize > 0" :value="itemBaseSize" type="primary" style="float: right;"></el-badge>
      </el-menu-item>
      <el-menu-item v-if="isAuthenticated" index="/history">
        <i class="el-icon-notebook-2"></i>
        <span>История</span>
        <el-badge v-if="historySize > 0" :value="historySize" type="primary" style="float: right;"></el-badge>
      </el-menu-item>
      <el-menu-item v-if="isAuthenticated" index="/export-items">
        <i class="el-icon-upload2"></i>
        <span>Экспорт предметов</span>
      </el-menu-item>
      <el-menu-item v-if="isAuthenticated" index="/import-items">
        <i class="el-icon-download"></i>
        <span>Импорт предметов</span>
      </el-menu-item>
      <el-menu-item index="/faq">
        <i class="el-icon-question"></i>
        <span>Руководства</span>
      </el-menu-item>
      <!-- <el-menu-item index="/updates">
        <i class="el-icon-s-claim"></i>
        <span>Обновления</span>
      </el-menu-item> -->
      <el-menu-item v-if="uid == 'LNgKWoXVvpS9bKKEUKzNJ4HX3sk1'" index="/suggest-recipes">
        <i class="el-icon-refresh"></i>
        <span>Замена рецептов в БД</span>
      </el-menu-item>
      <el-menu-item v-if="isAuthenticated" index="/profile">
        <i class="el-icon-s-operation"></i>
        <span>Настройки</span>
      </el-menu-item>
      <el-menu-item v-if="!isAuthenticated" @click="signInAnonymously()">
        <i class="el-icon-s-custom"></i>
        <span>Войти</span>
      </el-menu-item>
    </el-menu>
    <div style="text-align: center;">
      <span style="color: #909399; font-size: 12px;">Разработка NoxKeini</span><br>
      <span style="color: #909399; font-size: 12px;">Обновлено 17.11.2019</span><br>
      <el-link type="info" href="mailto:mcostsup@mail.ru" style="font-size: 12px;">mcostsup@mail.ru</el-link>
    </div>  
  </el-aside>  
</template>

<script>
  import firebase from 'firebase/app';
  require('firebase/auth');
  export default {
    data() {
      return {
        isAuthenticated: this.$store.state.user || false,
        uid: (this.$store.state.user) ? this.$store.state.user.uid : null,
        userCollectionSize: 0,
        itemBaseSize: 0,
      };
    },
    computed: {
      historySize() {
        var self = this;
        return self.$store.state.history.length;
      },
    },
    methods: {
      signInAnonymously(){
        var self = this;
        firebase.auth().signInAnonymously().then(function(){
          self.$router.push({name: 'profile'});
        });
      },
      /*getSizes(){

      },*/
    },
    mounted() {
      var self = this;
      // console.log(self.$store.state.user);
      // if (self.$store.state.user == null) {
        self.$store.subscribe((mutation, state) => {
          switch(mutation.type) {
            case 'updateUser':
              self.isAuthenticated = self.$store.state.user || false;
              if (self.isAuthenticated) {
                self.uid = self.$store.state.user.uid;                
              }; 
              if (self.$route.params.prevPage) {
                self.$router.push({name: self.$route.params.prevPage});
              };
              /*for (var prop in self.$store.state.itemCollection) {
                self.itemBaseSize = 0;
                self.itemBaseSize += self.$store.state.itemCollection[prop].length;
              };*/
            break;
            case 'updateItemCollection':
              // if (self.isAuthenticated) {
                // self.userCollectionSize = 0;
                self.itemBaseSize = 0;
                /*for (var prop in self.$store.state.userCollection) {
                  self.userCollectionSize += self.$store.state.userCollection[prop].length;
                };*/
                for (var prop in self.$store.state.itemCollection) {
                  self.itemBaseSize += self.$store.state.itemCollection[prop].length;
                };
              // };
            break;
            case 'updateUserCollection':
              if (self.isAuthenticated) {
                self.userCollectionSize = 0;
                // self.itemBaseSize = 0;
                // console.log(self.$store.state.userCollection);
                for (var prop in self.$store.state.userCollection) {
                  self.userCollectionSize += self.$store.state.userCollection[prop].length;
                };
                /*for (var prop in self.$store.state.itemCollection) {
                  self.itemBaseSize += self.$store.state.itemCollection[prop].length;
                };*/
              };
            break;
          };
        });
      // } else {
        // self.uid = self.$store.state.user.uid;
        // self.userCollectionSize = self.$store.state.userCollection.length;
      // }; 
    }
  }
</script>
